import * as React from 'react';

var focusableElementSelectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[tabindex]:not([tabindex^="-"]):not([disabled])', '*[contenteditable]'].join(',');
var TrapFocus = function TrapFocus(_ref) {
  var children = _ref.children,
      enabled = _ref.enabled;
  var containerRef = React.useRef();
  var restoreFocusRef = React.useRef(null);
  React.useEffect(function () {
    var containerElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;

    if (!containerElement || !enabled) {
      return;
    } // TODO: Tab-key handling is not supported in testing-library
    // istanbul ignore next


    var tabListener = function tabListener(e) {
      if (e.key !== 'Tab') {
        return;
      }

      var childElements = containerElement.querySelectorAll(focusableElementSelectors);

      if (childElements.length === 0) {
        return;
      }

      var firstElement = childElements[0];
      var lastElement = childElements[childElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', tabListener);
    return function () {
      document.removeEventListener('keydown', tabListener);
    };
  }, [containerRef.current, enabled]); // istanbul ignore next

  React.useEffect(function () {
    var containerElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;

    if (!containerElement || !enabled) {
      return;
    }

    if (document.activeElement && restoreFocusRef.current === null) {
      restoreFocusRef.current = document.activeElement;
    }

    containerElement.focus();
    return function () {
      if (restoreFocusRef.current && enabled) {
        restoreFocusRef.current.focus();
      }
    };
  }, [containerRef.current, enabled]);
  return /*#__PURE__*/React.cloneElement(children, {
    ref: containerRef,
    tabIndex: -1
  });
};

export { TrapFocus };
